import React, {useEffect, useState} from 'react';
import {useImageCache} from 'components/cacheable/ImageCacheContext';

const placeholderImage = '/images/emptyProfile.svg';

const UniversalProfileImage = ({id, size, cssClass = '', beRoundy = true, onClick}) => {
    const {profileGeto} = useImageCache();
    const [profileImage, setProfileImage] = useState(null);

    const style = {
        width: size ? size : undefined,
        height: size ? size : undefined,
        minHeight: size ? size : undefined,
        minWidth: size ? size : undefined,
        objectFit: 'cover',
        borderRadius: beRoundy ? '50%' : undefined
    };

    useEffect(() => {
        const loadImage = async () => {
            setProfileImage(placeholderImage);
            if (!id) {
                return;
            }
            const blob = await profileGeto.fetchBlob(id);
            const imageUrl = URL.createObjectURL(blob);
            console.log('[img] loaded profile image ' + imageUrl);
            setProfileImage(imageUrl);
        };
        loadImage();
    }, [id]);

    const localClick = () => {
        if (onClick) {
            onClick();
        }
    };

    return (
        <>
            {profileImage &&
                <img className={cssClass} src={profileImage} alt="Profile" style={style} onClick={localClick}/>}
        </>
    );
};

export default UniversalProfileImage;